import React, { useEffect, useState } from 'react';
import './Hero.css';
import headerlogo from '../assets/images/logo-white.png';

const Hero = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 384,
    minutes: 25,
    seconds: 45,
  });

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        let { hours, minutes, seconds } = prev;

        if (seconds > 0) {
          seconds -= 1;
        } else if (minutes > 0) {
          minutes -= 1;
          seconds = 59;
        } else if (hours > 0) {
          hours -= 1;
          minutes = 59;
          seconds = 59;
        }

        return { hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (num) => String(num).padStart(2, "0");

  const handleNotify = async () => {
    if (!email) {
      setMessage("Please enter a valid email.");
      return;
    }

    try {
      const response = await fetch("/api/requestinfo?email=" + email, {
        method: "GET"
      });

      if (response.ok) {
        setMessage("✅ Request Sent!");
        setEmail("");
      } else {
        setMessage("❌ Failed to send request. Try again.");
      }
    } catch (error) {
      setMessage("⚠️ Something went wrong. Try later.");
    }
  };

  return (
    <section className="hero">
      {/* Hero Logo */}
      <div className="hero-logo">
        <img src={headerlogo} alt="Nautio Logo" />
      </div>

      {/* Hero Content */}
      <div className="hero-content">
        <div className="hero-text">
          <p className="hero-title">The Yachting</p>
          <p className="hero-sub-heading">Social Media</p>
          <p className="hero-sub-heading">Ecosystem</p>

          <div
            className="hero-subtitle-container"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              marginTop: "1rem",
            }}
          >
            <p className="hero-subtitle">
              Find your <span style={{ fontWeight: "900" }}>best yacht deal</span> worldwide from around{" "}
              <span style={{ fontWeight: "900" }}>10,000 yachts.</span>
            </p>
            <p className="hero-subtitle">
              Find the matching people to share your{" "}
              <span style={{ fontWeight: "900" }}>yachting experience.</span>
            </p>
          </div>

          <div className="hero-notify-banner">
            Enter your email to get notified as soon as the app is ready.
          </div>

          {/* Email Input + Button */}
          <div className="hero-email-wrapper">
            <input
              type="email"
              placeholder="Email"
              className="hero-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button className="hero-email-button" onClick={handleNotify}>
              Notify Me
            </button>
          </div>

          {/* Feedback Message */}
          {message && <div className="hero-message">{message}</div>}

          <div className="stats-image-container">
            {/* Countdown Timer */}
            <div className="countdown-timer-text" style={{ width: "100%" }}>LAUNCH IN</div>
            <div className="countdown-timer">
              <div className="time-unit">
                <span className="time">{formatTime(timeLeft.hours)}</span>
                <span className="label">HOURS</span>
              </div>
              <div className="time-unit">
                <span className="time">{formatTime(timeLeft.minutes)}</span>
                <span className="label">MINUTES</span>
              </div>
              <div className="time-unit">
                <span className="time">{formatTime(timeLeft.seconds)}</span>
                <span className="label">SECONDS</span>
              </div>
            </div>

            {/* Stats Image */}
            <div className="hero-stats-image"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
